import React from 'react';
type BadgeVariant = 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info';
interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
  dot?: boolean;
}
const variantStyles: Record<BadgeVariant, string> = {
  default: 'bg-gray-100 text-gray-600 dark:bg-white/[0.07] dark:text-gray-300 ring-1 ring-gray-200/60 dark:ring-white/[0.06]',
  primary: 'bg-cyan-50 text-cyan-700 dark:bg-cyan-500/10 dark:text-cyan-300 ring-1 ring-cyan-200/60 dark:ring-cyan-500/20',
  success: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-300 ring-1 ring-emerald-200/60 dark:ring-emerald-500/20',
  warning: 'bg-amber-50 text-amber-700 dark:bg-amber-500/10 dark:text-amber-300 ring-1 ring-amber-200/60 dark:ring-amber-500/20',
  danger: 'bg-red-50 text-red-600 dark:bg-red-500/10 dark:text-red-400 ring-1 ring-red-200/60 dark:ring-red-500/20',
  info: 'bg-blue-50 text-blue-700 dark:bg-blue-500/10 dark:text-blue-300 ring-1 ring-blue-200/60 dark:ring-blue-500/20'
};
const dotColors: Record<BadgeVariant, string> = {
  default: 'bg-gray-400 dark:bg-gray-500',
  primary: 'bg-cyan-500',
  success: 'bg-emerald-500',
  warning: 'bg-amber-500',
  danger: 'bg-red-500',
  info: 'bg-blue-500'
};
export function Badge({
  children,
  variant = 'default',
  className = '',
  dot = false
}: BadgeProps) {
  return <span className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full text-xs font-medium ${variantStyles[variant]} ${className}`} data-id="element-5393">
      
      {dot && <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${dotColors[variant]}`} data-id="element-5394" />}
      {children}
    </span>;
}
export function getStatusBadgeVariant(status: string): BadgeVariant {
  switch (status) {
    case 'programada':
      return 'primary';
    case 'completada':
      return 'success';
    case 'cancelada':
      return 'danger';
    case 'reprogramada':
      return 'warning';
    default:
      return 'default';
  }
}